import React from 'react';
import '../styles/PrivacyPolicy.css'; // 必要に応じてCSSを作成

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h2>プライバシーポリシー</h2>
      <p>株式会社ITLIT（以下、「当社」といいます）は、当サイトの利用者のプライバシーを尊重し、個人情報の保護に努めます。本プライバシーポリシーは、当社が収集する情報、利用目的、及び管理方法について説明します。</p>
      
      <h3>1. 個人情報の定義</h3>
      <p>「個人情報」とは、氏名、住所、電話番号、メールアドレスなど、特定の個人を識別できる情報を指します。</p>
      
      <h3>2. 収集する情報</h3>
      <ul>
        <li>氏名、メールアドレス、お問い合わせ内容など</li>
        <li>アクセスログ、クッキー情報など</li>
      </ul>
      
      <h3>3. 情報の利用目的</h3>
      <ul>
        <li>サービス提供および品質向上</li>
        <li>お問い合わせへの対応</li>
        <li>必要に応じたご連絡</li>
      </ul>
      
      <h3>4. 第三者への提供</h3>
      <p>当社は、法令に基づく場合を除き、利用者の同意を得ずに第三者に個人情報を提供することはありません。</p>
      
      <h3>5. クッキーについて</h3>
      <p>当社は、利用者の利便性向上のため、クッキーを使用することがあります。</p>
      
      <h3>6. 情報の安全管理</h3>
      <p>当社は、個人情報の安全管理のため、適切な措置を講じています。</p>
      
      <h3>7. 個人情報の開示・訂正・削除</h3>
      <p>利用者は、自身の個人情報について、開示、訂正、削除を希望する場合、当社までご連絡ください。</p>
      
      <h3>8. お問い合わせ窓口</h3>
      <p>本ポリシーに関するお問い合わせは、以下までお願いいたします。</p>
      <p>メールアドレス: support@itlitt.co.jp</p>
      
      <h3>9. プライバシーポリシーの変更</h3>
      <p>当社は、必要に応じて本プライバシーポリシーを改定する場合があります。改定後の内容は当サイトにて公表します。</p>
      
      <p>制定日：2024年1月1日</p>
    </div>
  );
};

export default PrivacyPolicy;
